import PigsUnderCareLine from './PigsUnderCareLine';

export default PigsUnderCareLine;
